import InfoToggletip from 'components/InfoToggletip';
import { color } from 'styles/globals';
import { ParseHtmlDefault } from 'utils/miscUtils/rawHtml';
import * as S from './ProductCardStyles';

interface ContentTableValues {
  title: string;
  value: string;
  toggletipContent?: string;
}

export interface ContentTableProps {
  title?: string;
  values: ContentTableValues[];
}

const ContentTable = ({ title, values }: ContentTableProps) => (
  <S.TableWrapper>
    <S.TableTitle>{title}</S.TableTitle>
    <S.Table>
      <tbody>
        {values.map((item: ContentTableValues, index: number) => (
          <S.TableRow key={`${item.title}-${index}`}>
            <S.RowLabel>{item.title}</S.RowLabel>
            <S.RowValue>
              {ParseHtmlDefault(item.value)}
              {item.toggletipContent && (
                <InfoToggletip
                  content={item.toggletipContent}
                  position='bottom-left'
                  color={color.recommendsDarkGreen}
                />
              )}
            </S.RowValue>
          </S.TableRow>
        ))}
      </tbody>
    </S.Table>
  </S.TableWrapper>
);

export default ContentTable;
